<template>
  <div>
    <h4 class="header" v-html="data.question" />
    <form>
      <template v-for="(response, i) in data.responses">
        <div class="ui field" :key="`response-${i}`">
          <div class="ui green sata checkbox">
            <input type="checkbox" v-model="answers[i]" :disabled="submitted" />
            <label>
              <span v-html="response.text" />
              <span
                class="ui green text"
                v-if="submitted && response.correct"
              >&nbsp;(Correct answer)</span>
            </label>
          </div>
        </div>
      </template>
    </form>
    <p class="disclaimer"><i>*Interactions are designed to help learning retention only. Interaction data is not stored for reporting.</i></p>
    <div class="ui success message" v-if="showCorrectFeedback">{{ data.correct_feedback }}</div>
    <div class="ui error message" v-if="showIncorrectFeedback">{{ data.incorrect_feedback }}</div>
  </div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';

export default {
  name: 'SelectAllThatApply',
  props: ['id', 'type', 'data', 'standard'],
  data() {
    return {
      answers: [],
      submitted: false,
      isCorrect: null,
    };
  },
  computed: {
    showCorrectFeedback() {
      return this.submitted && this.isCorrect;
    },
    showIncorrectFeedback() {
      return this.submitted && !this.isCorrect;
    },
  },
  methods: {
    saveSCORMInteraction() {
      const scormData = {
        id: this.id,
        type: this.type,
        isCorrect: this.isCorrect,
        answer: this.answers,
        description: this.data.question,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
    checkIsValid() {
      let valid = false;
      for (let i = 0; i < this.answers.length; i++) {
        if (this.answers[i] === true) {
          valid = true;
          break;
        }
      }
      this.$emit('valid', valid);
    },
    submit() {
      let allCorrect = true;
      for (let i = 0; i < this.answers.length; i++) {
        if (this.answers[i] !== this.data.responses[i].correct) {
          allCorrect = false;
          break;
        }
      }
      this.isCorrect = allCorrect;
      this.submitted = true;
      if (this.standard === 'SCORM_2004') {
        this.saveSCORMInteraction();
      }
      this.$emit('valid', false);
    },
  },
  mounted() {
    if (this.data.responses && this.data.responses.length > 0) {
      this.data.responses.forEach(response => {
        this.answers.push(false);
      });
    }
    $('.ui.sata.checkbox').checkbox();
  },
  watch: {
    'data.responses'(val, old) {
      this.answers = [];
      if (val && val.length > 0) {
        val.forEach(response => {
          this.answers.push(false);
        });
      }
    },
    answers() {
      this.checkIsValid();
    },
  },
};
</script>
